/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { RolePermissionViewModel } from "../types/RolePermissionViewModel.ts";

export const rolePermissionViewModelSchema = z.object({
  controllerId: z.optional(
    z
      .number()
      .int()
      .describe("ID do controller ao qual as permissões se aplicam."),
  ),
  canRead: z.optional(
    z
      .boolean()
      .describe(
        "Define se o perfil possui permissão de leitura neste controller.",
      ),
  ),
  canCreate: z.optional(
    z
      .boolean()
      .describe(
        "Define se o perfil possui permissão de criação neste controller.",
      ),
  ),
  canUpdate: z.optional(
    z
      .boolean()
      .describe(
        "Define se o perfil possui permissão de edição neste controller.",
      ),
  ),
  canDelete: z.optional(
    z
      .boolean()
      .describe(
        "Define se o perfil possui permissão de exclusão neste controller.",
      ),
  ),
}) as unknown as ToZod<RolePermissionViewModel>;
